import { ACTION_TYPES } from '../../actions';
import { setToken } from '../../core/authUtil';

const INIT_STATE = {
  user: {}
};

const processUserInfo = (userInfo) => {
  const {
    id, userName, userNick,
    authorities,
  } = userInfo;
  return { id, authorities, userName, userNick };
}

export default function auth(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 登录成功
    case ACTION_TYPES.LOG_IN:
      setToken(payload);
      break;
    case ACTION_TYPES.GET_AUTH_PROFILE:
      result.user = processUserInfo(payload);
      break;
    default:
      result = state;
  }
  return result;
}
